import {type AppDispatch, type RootState} from "../../../../store";
import {landlordAddUnitWriteToStorageV2} from "../utils/landlordAddUnitHandleStorageV2";

export const landlordCreateUnitIdVerification  = (unitID?: number) => (data: any) => async (dispatch: AppDispatch, getState: () => RootState): Promise<any> => {
    landlordAddUnitWriteToStorageV2('landlord_create_unit_id_verification', data)
    return {
        isSuccessful: true,
        textNavigate: '/landlord/modal/v2/landlord_create_unit_upload_title_deed/-/-',
        textNotification: ''
    }
}